// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type { GetFeishuSessionsQuery, BaseResponseListFeishuSessionFoundResponse } from '../types';

/**
 * 分页会话详情
 *
 * @export
 * @tags feishu-session-controller
 * @link [GET] /feishuSessions
 */
export function getFeishuSessions(): Promise<BaseResponseListFeishuSessionFoundResponse>;
export function getFeishuSessions(
    options: ApiOptions<never, GetFeishuSessionsQuery>
): Promise<BaseResponseListFeishuSessionFoundResponse>;
export function getFeishuSessions(
    options?: ApiOptions<never, GetFeishuSessionsQuery>
): Promise<BaseResponseListFeishuSessionFoundResponse> {
    return request<never, never, GetFeishuSessionsQuery>('/feishuSessions', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getFeishuSessions',
    });
}

export const meta = [
    { tags: ['feishu-session-controller'], path: '/feishuSessions', method: 'get' },
];
